import { render, staticRenderFns } from "./ElemOrg.vue?vue&type=template&id=7c83e8b3&"
import script from "./ElemOrg.vue?vue&type=script&lang=js&"
export * from "./ElemOrg.vue?vue&type=script&lang=js&"
import style0 from "./ElemOrg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports